import service from "@/api/service";
import { SearchRequest } from "@/api/design-shop/request";
import { SearchResponse } from "@/api/design-shop/response";

/**
 * デザイン店舗一覧検索APIをコールします。
 *
 * @param searchRequest 検索のリクエストボディ
 * @return SearchResponse
 */
export async function search(searchRequest: SearchRequest) {
  const response = await service.post("/search-design-shop", searchRequest);
  return response.data as SearchResponse;
}
